var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M271.8 176.559A81.028 81.028 0 0 0 256 175c-44.664 0-81 36.336-81 81s36.336 81 81 81 81-36.336 81-81c0-5.406-.543-10.688-1.559-15.8l-47.62 47.62C279.32 296.32 268.02 301 256 301s-23.32-4.68-31.82-13.18S211 268.02 211 256s4.68-23.32 13.18-31.82zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.09 150.188-32.274 32.273a45.067 45.067 0 0 1-10.8 7.988C453.125 211.008 457 233.06 457 256c0 110.832-90.168 201-201 201S55 366.832 55 256 145.168 55 256 55c22.95 0 45.012 3.879 65.574 10.992a45.024 45.024 0 0 1 7.969-10.812l32.27-32.27C329.543 8.203 293.714 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256c0-37.715-8.203-73.543-22.91-105.813zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.71 128.648-2.733-32.406C298.027 88.98 277.473 85 256 85c-94.29 0-171 76.71-171 171s76.71 171 171 171 171-76.71 171-171c0-21.473-3.98-42.027-11.242-60.977l-32.406-2.734-23.786 23.781C364.363 228.47 367 241.93 367 256c0 61.207-49.793 111-111 111s-111-49.793-111-111 49.793-111 111-111c14.07 0 27.531 2.637 39.93 7.434zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.41 88.262 4.367 51.75-105.382 105.383c-5.86 5.855-5.86 15.355 0 21.21C248.32 269.535 252.16 271 256 271s7.68-1.465 10.605-4.395l105.383-105.382 51.75 4.363a15.001 15.001 0 0 0 11.867-4.34l63.637-63.64a14.998 14.998 0 0 0 3.485-15.758 14.998 14.998 0 0 0-12.829-9.793l-46.07-3.887-3.883-46.066a15.001 15.001 0 0 0-25.554-9.348l-63.637 63.64a15 15 0 0 0-4.344 11.868zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.874d1f6b9d8648b881fac8bec761fd75.svg";
export { ForwardRef as ReactComponent };